import { render, staticRenderFns } from "./EstudioSe.vue?vue&type=template&id=56b1578e&"
import script from "./EstudioSe.vue?vue&type=script&lang=js&"
export * from "./EstudioSe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports